<script setup>
import { Link } from '@inertiajs/vue3'
import { Button } from '@codinglabsau/gooey'
import { HeartIcon } from '@heroicons/vue/24/outline'

defineProps({
  reason: String,
})
</script>

<template>
  <div
    v-if="!$page.props.auth.user?.supporter"
    class="flex flex-col space-y-4 rounded-md bg-primary/5 p-4 text-center"
  >
    <p class="mt-1 text-sm text-gray-500">
      {{ reason }}
    </p>
    <Link :href="route('account.billing.show')" rel="nofollow">
      <Button variant="outline">
        <HeartIcon class="-ml-0.5 mr-1.5 size-5" aria-hidden="true" />
        Become a Supporter
      </Button>
    </Link>
  </div>
</template>
